import { getAccessToken } from './auth';

export const FP_API_BASE = 'https://fp-api.focuspointintl.com';

export const DEV2_DEVICE_TEST_SCHEDULE_PATH = '/api/dev2/device-test/schedule';
export const DEV2_DEVICE_TEST_VALIDATE_PATH = '/api/dev2/device-test/validate';
export const DEV2_DEVICE_TEST_SOS_PATH = '/api/dev2/device-test/sos';
export const DEV2_DEVICE_TEST_SMS_PATH = '/api/dev2/device-test/sms';

async function postDev2Passthrough(path, body) {
  const accessToken = await getAccessToken();
  if (!accessToken) {
    throw new Error('Authentication failed');
  }

  const response = await fetch(`${FP_API_BASE}${path}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error(`Request failed (${response.status})`);
  }

  if (response.status === 401) {
    throw new Error(data.message || 'Session expired — sign in again');
  }

  return { httpStatus: response.status, ...data };
}

export function postDev2Schedule(body) {
  return postDev2Passthrough(DEV2_DEVICE_TEST_SCHEDULE_PATH, body);
}

export function postDev2Validate(body) {
  return postDev2Passthrough(DEV2_DEVICE_TEST_VALIDATE_PATH, body);
}

export function postDev2Sos(body) {
  return postDev2Passthrough(DEV2_DEVICE_TEST_SOS_PATH, body);
}

export function postDev2Sms(body) {
  return postDev2Passthrough(DEV2_DEVICE_TEST_SMS_PATH, body);
}
